/* unplugin-vue-components disabled */import { ElTree as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/tree/style/css';
import { ElForm as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElInput as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElDivider as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/divider/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  style: {
    "width": "720px"
  }
};
import { apiRoleMyRoleList, apiRoleDetail } from '@/api/user';
import { apiGetUserRole, apiBindUserRole, apiGetUserRolePermissionTree } from '@/api/roleTree';
export default /*#__PURE__*/_defineComponent({
  __name: 'addEditRoleGroup',
  props: {
    type: {
      type: String,
      required: true
    },
    active: {
      type: String,
      default: ''
    },
    roleId: {
      type: Number,
      required: true
    }
  },
  emits: ['success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const myRoleList = ref([]);
    const roleDetail = ref();
    const ruleForm = ref();
    const confirmLoading = ref(false);
    const loadDetail = ref(false);
    const treeRef = ref();
    const roleTree = ref([]);
    const form = ref({
      role_parent_id: '',
      name: '',
      remark: ''
    });
    const rules = reactive({
      role_parent_id: {
        required: true,
        message: '请选择上级角色组',
        trigger: 'change'
      },
      name: {
        required: true,
        message: '请输入角色组名',
        trigger: 'blur'
      }
    });
    const customNodeClass = (data, node) => {
      if (data.isPenultimate) {
        return 'is-penultimate';
      }
      return null;
    };
    const propTree = {
      label: 'name',
      class: customNodeClass
    };
    const getMyRoleList = () => {
      apiRoleMyRoleList().then(res => {
        if (res.code === 0) {
          myRoleList.value = res.data;
          if (props.roleId === 0) {
            getUserRole(res.data[0].Id, res => {
              // defaultExpandedKeys.value = res.data;
            });
            // parentRoleItem.value = res.data[0];
          } else {
            getRoleDetail();
          }
        }
      });
    };
    const getUserRolePermissionTree = () => {
      apiGetUserRolePermissionTree().then(res => {
        if (res.code === 0) {
          roleTree.value = res.data;
          if (props.type !== 'add') {
            getUserRole(props.roleId, res => {
              res.data.forEach(key => {
                setCheckedNodes(key);
              });
            });
          }
        }
      });
    };
    // 获取用户的权限
    const getUserRole = (role_id, cb) => {
      if (role_id) {
        apiGetUserRole({
          role_id: String(role_id)
        }).then(res => {
          if (res.code == 0) {
            cb && cb(res);
          }
        });
      }
    };
    const getRoleDetail = () => {
      if (props.roleId <= 0) return;
      loadDetail.value = true;
      apiRoleDetail({
        RoleId: props.roleId
      }).then(res => {
        if (res.code === 0) {
          roleDetail.value = res.data;
          form.value.name = res.data.Name;
          form.value.remark = res.data.Remark;
          form.value.role_parent_id = res.data.ParentRoleId || 1;
          // getUserRole(res.data.ParentRoleId, (res: any) => {
          // 	// defaultExpandedKeys.value = res.data;
          // 	// console.log(defaultExpandedKeys.value);
          // });
        }
      }).finally(() => {
        loadDetail.value = false;
      });
    };
    const handleCheck = (data, objKeys) => {
      const isSelected = objKeys.checkedKeys.includes(data.unique_key);
      // 当前节点
      const curNode = treeRef.value.getNode(data.unique_key);
      // 获取子节点
      const nodes = curNode.childNodes || [];
      setNodes(nodes, isSelected);
      if (isSelected) {
        // 当前节点选中，父节点一点选中，但是取消当前节点不影响父节点(实现父节点的单独选中)
        const keys = getParentKey(curNode.parent);
        keys.forEach(key => {
          setCheckedNodes(key);
        });
      }
    };
    const setCheckedNodes = (key, deep = false) => {
      treeRef.value.setChecked(key, true, deep);
    };
    // 手动修改node节点的 checked 属性
    const setNodes = (list = [], flag = false) => {
      if (!list.length) return [];
      for (let item of list) {
        item.checked = flag;
        if (item.childNodes && item.childNodes.length) {
          setNodes(item.childNodes, flag);
        }
      }
    };
    // 获取父级节点的key
    const getParentKey = (node, ret = []) => {
      node.key && ret.push(node.key);
      if (node.parent) {
        getParentKey(node.parent, ret);
      }
      return ret;
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          confirmLoading.value = true;
          let params = JSON.parse(JSON.stringify(form.value));
          params.role_id = props.roleId || 0;
          params.items = treeRef.value.getCheckedKeys();
          apiBindUserRole({
            ...params
          }).then(res => {
            if (res.code === 0) {
              emits('success', 'roleGroup');
            }
          }).finally(() => {
            confirmLoading.value = false;
          });
        }
      });
    };
    watch(() => props.active, val => {
      if (val === 'addEditRoleGroup') {
        if (props.type === 'add') {
          form.value = {
            role_parent_id: '',
            name: '',
            remark: ''
          };
        }
        getUserRolePermissionTree();
        getMyRoleList();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_divider = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_el_form_item = __unplugin_components_4;
      const _component_el_input = __unplugin_components_5;
      const _component_el_form = __unplugin_components_6;
      const _component_el_tree = __unplugin_components_7;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "addEditRoleGroup"
      }, {
        default: _withCtx(() => [__props.type !== 'check' ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#addEditRoleGroup"
        }, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleOk(_unref(ruleForm)))
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [_createTextVNode("基本信息")]),
          _: 1
        }), _createVNode(_component_el_form, {
          ref_key: "ruleForm",
          ref: ruleForm,
          model: _unref(form),
          rules: _unref(rules),
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "上级角色组：",
            prop: "role_parent_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              disabled: __props.type === 'check',
              modelValue: _unref(form).role_parent_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).role_parent_id = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(myRoleList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  data: item,
                  value: item.Id,
                  key: item.Id,
                  label: item.Name
                }, null, 8, ["data", "value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["disabled", "modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "角色组名",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              disabled: __props.type === 'check',
              modelValue: _unref(form).name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).name = $event)
            }, null, 8, ["disabled", "modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              disabled: __props.type === 'check',
              modelValue: _unref(form).remark,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).remark = $event)
            }, null, 8, ["disabled", "modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"]), _createVNode(_component_el_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [_createTextVNode("功能权限")]),
          _: 1
        }), _createVNode(_component_el_tree, {
          data: _unref(roleTree),
          ref_key: "treeRef",
          ref: treeRef,
          "show-checkbox": "",
          "default-expand-all": "",
          "node-key": "unique_key",
          "check-strictly": true,
          props: propTree,
          onCheck: handleCheck
        }, null, 8, ["data"])])]),
        _: 1
      });
    };
  }
});